import Chip from '@mui/material/Chip'
import { Link2Station } from 'lib/links'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
  chip: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1)
  }
}))

export default function ChipStation ({ name, slug }) {
  const classes = useStyles()

  if (!name || !slug) return null

  return (
    <Link2Station slug={slug}>
      <Chip
        label={name}
        variant='outlined'
        component='a'
        clickable
        data-test='chip-station'
        title={'Sender: ' + name}
        className={classes.chip}
      />
    </Link2Station>
  )
}
